import React from 'react';
import './SubPages.css';
import HomeButton from './HomeButton';
import Footer from './Footer';

const About = () => (
  <div className="subpage-container">
     <HomeButton />
    <h1>About OZIA AI</h1>
    <div className="subpage-content">
      <p>OZIA AI was founded on the principle that advanced artificial intelligence should be a seamless extension of human thought. Our mission is to bridge the gap between complex data and actionable insights.</p>
      <h2>Our Vision</h2>
      <p>We believe in a future where AI isn't just a tool, but a collaborative partner that respects privacy and empowers creativity.</p>
    </div>
                <div className="footer-wrapper">
                <Footer />
            </div>
  </div>
);

export default About;